








import { Component, Mixins, Prop, Provide, Watch } from 'vue-property-decorator';
import MixinCharts from '@/plugins/podolib/services/helper/mixins/chart/standard';
import { DrawSVG } from '@/plugins/podolib/services/charts/prosup-feet/angles-prosup-running-feet';
import i18n from '@/plugins/i18n';
import { get } from 'lodash';

@Component
export default class ChartRunningPhaseAngles extends Mixins(MixinCharts) {
  @Prop({ default: 'heel_strike' }) angleType!: 'heel_strike' | 'toe_off' | 'flat_foot';
  @Prop({ default: 230 }) width!: number;
  @Prop({ required: false, default: null }) keyName!: string | null;

  @Provide() graphCanvas: DrawSVG | null = null;

  get isNewAnalysis() {
    return this.$pdc.helper?.isNewAnalysis(this.values);
  }

  get heelStrike() {
    return {
      left: this.values.aggregates.left.angle_foot_in.avg,
      right: this.values.aggregates.right.angle_foot_in.avg,
    };
  }
  get flatFoot() {
    return this.isNewAnalysis
      ? {
          left: this.values.aggregates.left.angle_flat_foot.avg,
          right: this.values.aggregates.right.angle_flat_foot.avg,
        }
      : {
          left: 0,
          right: 0,
        };
  }
  get toeOff() {
    return {
      left: this.values.aggregates.left.angle_foot_out.avg,
      right: this.values.aggregates.right.angle_foot_out.avg,
    };
  }

  get angles(): any {
    return {
      heel_strike: {
        left: this.getAngleUnit(this.heelStrike.left),
        right: this.getAngleUnit(this.heelStrike.right),
      },
      toe_off: {
        left: this.getAngleUnit(this.toeOff.left),
        right: this.getAngleUnit(this.toeOff.right),
      },
      flat_foot: {
        left: this.getAngleUnit(this.flatFoot.left),
        right: this.getAngleUnit(this.flatFoot.right),
      },
    };
  }
  get angle() {
    return this.angles[this.angleType];
  }

  @Watch('values', { deep: true })
  onValuesChange() {
    this.draw();
  }

  // Because some acquisitions dev/beta are in degrees and in prod there are in radians
  getAngleUnit(val: number) {
    if (this.isNewAnalysis) return val; // Degree values
    const radVal = this.$pdc.helper!.radToDeg(val);
    if (radVal >= 100 || radVal <= -100) {
      return val;
    } else {
      return radVal;
    }
  }

  draw() {
    this.graphCanvas = new DrawSVG(
      this.$refs['canvas'] as HTMLCanvasElement,
      this.angleType,
      this.angle.left,
      this.angle.right,
      this.keyName,
    );
    requestAnimationFrame(() => {
      this.graphCanvas!.draw();
    });
  }

  mounted() {
    this.draw();
  }
}
